import React from "react";
import { Space, Typography } from "antd";
import THEME from "../theme";
import { formatMoney } from "../utils";

const { Text } = Typography;

const StatBox = ({
  title,
  value,
  suffix = "บาท",
  color = THEME.primary,
  icon,
}) => (
  <div
    style={{
      background: `${color}08`,
      padding: "16px 20px",
      borderRadius: "10px",
      borderLeft: `4px solid ${color}`,
    }}
  >
    <Space align="start">
      {icon && (
        <div
          style={{
            background: color,
            padding: 8,
            borderRadius: 8,
            color: "#fff",
          }}
        >
          {icon}
        </div>
      )}
      <div>
        <Text type="secondary" style={{ fontSize: 16, display: "block" }}>
          {title}
        </Text>
        <Text strong style={{ fontSize: 18, color }}>
          {formatMoney(value)}
        </Text>
        <Text type="secondary" style={{ fontSize: 16, marginLeft: 4 }}>
          {suffix}
        </Text>
      </div>
    </Space>
  </div>
);

export default StatBox;
